module.exports = __webpack_public_path__ + "fonts/EuroStyleNormal.6bd8c8f.woff";